import { quantityOrderedStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsQuantityOrdered";
import { TYPOGRAPHY } from "@tCentro/theme/design";
import { css } from "styled-components";

Object.assign(quantityOrderedStyles, {
    quantityOrdered: {
        cssOverrides: {
            formField: css`
                margin-top: 10px;
                width: initial;
                flex-direction: row !important;
                align-items: center;

                label {
                    font-weight: ${TYPOGRAPHY.weight.mediumbold};
                    font-size: ${TYPOGRAPHY.size.base};
                    line-height: 24px;
                    width: 35% !important;
                }

                > div {
                    margin-top: 0 !important;

                    input {
                        padding: 12px 18px 12px 24px !important;
                        height: 48px !important;
                        width: 130px !important;
                        border: 1px solid #262525;
                        text-align: center;
                        margin: 0px 12px 0px 8px;
                    }
                }

                @media (min-width: 992px) and (max-width: 1180px) {
                    > div {
                        input {
                            width: 150px !important;
                        }
                    }
                }

                @media (max-width: 991px) {
                    > div {
                        input {
                            width: 150px !important;
                        }
                    }
                }

                @media (max-width: 420px) {
                    > div {
                        input {
                            width: 130px !important;
                        }
                    }
                }
            `,
        },
    },
});
